import getApiHeaders from 'utils/getApiHeaders'
import { indexNodeLicensesBaseUrl } from 'state/services/indexNode/indexNode'

export async function downloadNodeStorageFile(params: {
  account: string
  accessToken: string
  licenseId: string
  path: string
  filenameHint?: string
}): Promise<void> {
  const headers = getApiHeaders({ account: params.account, accessToken: params.accessToken })
  const base = indexNodeLicensesBaseUrl.replace(/\/$/, '')
  const url = `${base}/licenses/${params.licenseId}/storage/file?path=${encodeURIComponent(params.path)}`
  const res = await fetch(url, { headers })
  if (!res.ok) {
    throw new Error(`Download failed (${res.status})`)
  }
  const blob = await res.blob()
  const a = document.createElement('a')
  const href = URL.createObjectURL(blob)
  a.href = href
  a.download = params.filenameHint ?? params.path.split('/').filter(Boolean).pop() ?? 'download'
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(href)
}
